"use strict";
import _ from "lodash";
import configStore from "../../stores/configStore";
import createClasses from "../createClasses";
import { isSameDay } from "date-fns";
import { TZDate } from "@date-fns/tz";
import L from "../../leaflet";
import getHashtagFromNode from "../drawerHelper";
const meetings = (container, node) => {
  var _a;
  let { i18n, images, locale, defaultLocale } = configStore.getState();
  defaultLocale = ((_a = node == null ? void 0 : node.extendedData) == null ? void 0 : _a.defaultLocale) || defaultLocale;
  if (!_.isEmpty(node.imageUrl)) {
    const image = L.DomUtil.create(
      "img",
      "decidimGeo__drawer__listCardImg decidimGeo__drawer__listCardImg--large",
      container
    );
    image.src = node.imageUrl;
    container.className += " decidimGeo__drawer__listCardInfo--image";
  }
  const infoType = L.DomUtil.create("div", "decidimGeo__drawer__listCardType", container);
  const infoTxt = L.DomUtil.create(
    "span",
    createClasses("decidimGeo__drawer__listCardTxt"),
    infoType
  );
  infoTxt.textContent = i18n[node.resourceType];
  const infoTitle = L.DomUtil.create(
    "div",
    "decidimGeo__drawer__listCardTitle",
    container
  );
  infoTitle.textContent = getHashtagFromNode(node, locale, defaultLocale);
  const infoDescription = L.DomUtil.create(
    "div",
    "decidimGeo__drawer__listCardDate",
    container
  );
  const infoStart = L.DomUtil.create(
    "strong",
    "decidimGeo__drawer__listCardStartDate",
    infoDescription
  );
  let match = node.startDate.match(/([+-]\d{2}:\d{2})$/);
  let timezone = match ? match[1] : null;
  let startDate = new TZDate(node.startDate, timezone);
  let endDate = new TZDate(node.endDate, timezone);
  let displayedDate = format(startDate, "dd/MM/yyyy", { in: tz(timezone) }) + "-" + format(endDate, "dd/MM/yyyy", { in: tz(timezone) });
  if (isSameDay(startDate, endDate)) {
    displayedDate = format(startDate, "dd/MM/yyyy", { in: tz(timezone) });
  }
  infoStart.textContent = displayedDate;
  const infoStartSep = L.DomUtil.create(
    "span",
    "decidimGeo__drawer__listCardStartDateSep",
    infoDescription
  );
  infoStartSep.textContent = "\xB7";
  const infoStartTime = L.DomUtil.create(
    "span",
    "decidimGeo__drawer__listCardStartTime",
    infoDescription
  );
  let timeFormat = i18n["decidim.geo.time.formats.12h_24h"];
  const formatMap = {
    "%H:%M": "HH:mm",
    "%I:%M %p": "hh:mm aa"
  };
  timeFormat = formatMap[timeFormat] || timeFormat;
  let displayedTime = format(startDate, timeFormat, { in: tz(timezone) }) + "-" + format(endDate, timeFormat, { in: tz(timezone) });
  infoStartTime.textContent = displayedTime;
  if (node.descriptionHtml) {
    const infoDescription2 = L.DomUtil.create(
      "div",
      "decidimGeo__drawer__listCardDescription decidimGeo__drawer__listCardDescription--large decidimGeo__drawer__listCardDescription--meetings",
      container
    );
    infoDescription2.innerHTML = node.descriptionHtml[locale] || node.descriptionHtml[defaultLocale];
  }
};
export default meetings;
